// Google Ads (gtag.js) — Consent Mode v2 bridge.
//
// gtag.js itself is loaded in index.html with all storage defaults set to
// "denied" BEFORE the library executes. This module is the runtime bridge
// between our cookie banner (AAConsent) and Google's consent state:
// when the visitor grants/revokes Marketing or Statistics, we flip the
// matching signals via gtag('consent', 'update', ...).
//
// Mapping:
//   marketing  → ad_storage, ad_user_data, ad_personalization
//   statistics → analytics_storage
//
// Until consent flips to "granted", gtag fires only cookieless pings.
// Google can still model conversions for ad accounts; no identifiers leave
// the browser.

export const GOOGLE_ADS_CONVERSION_ID = 'AW-18148879279';

function gtagSafe(...args) {
  if (typeof window === 'undefined') return;
  // The gtag() stub is defined inline in index.html, so it's always present
  // by the time React boots. Fall back to a direct dataLayer push just in case.
  if (typeof window.gtag === 'function') {
    window.gtag(...args);
  } else {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(args);
  }
}

export function updateGoogleConsent({ statistics, marketing }) {
  const adState = marketing ? 'granted' : 'denied';
  const analyticsState = statistics ? 'granted' : 'denied';
  gtagSafe('consent', 'update', {
    ad_storage: adState,
    ad_user_data: adState,
    ad_personalization: adState,
    analytics_storage: analyticsState,
  });
}

// Fire a Google Ads conversion. Safe to call without consent: gtag.js will
// only persist identifiers if the corresponding consent signal is granted.
export function trackAdsConversion(sendTo, params = {}) {
  gtagSafe('event', 'conversion', { send_to: sendTo, ...params });
}
